const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-page-navi'] = {
        c: () => require('partner/modules/ecomm-page-navi/ecomm-page-navi.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-page-navi',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-page-navi'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-page-navi|ecomm-page-navi'] = {
                c: () => require('partner/modules/ecomm-page-navi/ecomm-page-navi.view.tsx'),
                cn: '__local__-__local__-ecomm-page-navi'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };